<!-- 类table的列表图 -->
<style lang="stylus" scoped>
.table {
  width: 100%;
  height: 22vh;
  margin: 0 auto;
  color: #fff;
  text-align: center;
  // overflow: hidden;


  .bar3D {
    width: 100%;
    height: 120%;
    margin-top:-1vh;

    .main {
      width: 100%;
      height: 100%;
    }
  }
}
</style>

<template>
  <boxWrap :name="name">
    <div class="table">
      <div class="bar3D">
        <div class="main"></div>
      </div>
    </div>
  </boxWrap>
</template>

<script>
import boxWrap from "../common/boxWrap";
import echarts from "echarts";
var placeHolderStyle = {
  normal: {
    label: {
      show: false
    },
    labelLine: {
      show: false
    }
  }
};
export default {
  // props: ["salesData", "salesDataBar"],
  data() {
    return {
      name: "会员复购率",
      dataY: [],
      dataX: [],
      tableData: [],
      chartData: [],
      swiperOption: {
        slidesPerView: "auto",
        // 是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
        notNextTick: true,
        // 循环
        loop: true,
        // 设定初始化时slide的索引
        initialSlide: 0,
        roundLengths: true,
        height: 180,
        // 自动播放
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          /* 触摸滑动后是否继续轮播 */
          disableOnInteraction: false
        },
        // 滑动速度
        speed: 800,
        // 滑动方向
        direction: "vertical",
        // 小手掌抓取滑动
        grabCursor: true
      }
    };
  },
  components: {
    boxWrap
  },
  methods: {
    init() {
      window.addEventListener(
        "resize",
        function() {
          this.myChart.resize();
        }.bind(this)
      );
    },
    getData(percent) {
      return [
        {
          value: percent,
          name: percent
        },
        {
          value: 1 - percent,
          itemStyle: {
            normal: {
              color: "transparent"
              // color: "#05296D"
            }
          }
        }
      ];
    },
    // getData() {
    //   this.myChart = echarts.init(document.querySelector(".bar3D .main"));
    //   this.myChart.clear();
    //   this.chart();
    // },
    chart() {
      this.data = ["15.80%", "20.50%", "16.15%", "30.90%", "25.90%"];
      this.xdata = ["领抵扣券", "大转盘", "翻牌活动", "微信红包", "刮刮乐"];
      var obj = {
        领抵扣券: 10,
        大转盘: 11,
        翻牌活动: 12,
        微信红包: 13,
        刮刮乐: 14
      };
      const data = this.chartData;
      this.myChart = echarts.init(document.querySelector(".bar3D .main"));
      var op = {
        color: [
          "rgb(14,109,233)",
          "rgb(0,175,109)",
          "#F4BB0C",
          "rgb(172,78,211)",
          "rgb(249,123,123)"
        ],
        yAxis: [
          {
            type: "category",
            inverse: true,
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              interval: 0,
              inside: true,
              textStyle: {
                color: "#0EFCFF",
                fontSize: 14
              },
              show: true
            },
            data: this.data
          }
        ],
        xAxis: [
          {
            show: false
          }
        ],
        legend: {
          bottom: "10",
          itemHeight: 16,
          itemWidth: 16,
          data: this.xdata,
          textStyle: {
            color: "#fff",
            fontSize: 16
          },
          top: "center",
          left: "70%"
          // formatter: function(name) {
          //   return name + obj[name] + "人";
          // }
        },
        grid: {
          top: "10%",
          bottom: "55%",
          left: "40%",
          containLabel: false
        },
        series: [
          {
            name: this.xdata[0],
            type: "pie",
            clockWise: false,
            hoverAnimation: false,
            radius: [100, 110],
            center: ["40%", "50%"],
            itemStyle: placeHolderStyle,
            data: this.getData(0.658)
          },
          {
            name: this.xdata[1],
            type: "pie",
            clockWise: false,
            hoverAnimation: false,
            radius: [80, 90],
            center: ["40%", "50%"],
            itemStyle: placeHolderStyle,
            data: this.getData(0.605)
          },
          {
            name: this.xdata[2],
            type: "pie",
            clockWise: false,
            hoverAnimation: false,
            radius: [60, 70],
            center: ["40%", "50%"],
            itemStyle: placeHolderStyle,
            data: this.getData(0.6615)
          },
          {
            name: this.xdata[3],
            type: "pie",
            clockWise: false,
            hoverAnimation: false,
            radius: [40, 50],
            center: ["40%", "50%"],
            itemStyle: placeHolderStyle,
            data: this.getData(0.709)
          },
          {
            name: this.xdata[4],
            type: "pie",
            clockWise: false,
            hoverAnimation: false,
            radius: [20, 30],
            center: ["40%", "50%"],
            itemStyle: placeHolderStyle,
            data: this.getData(0.759)
          }
        ]
      };
      this.myChart.setOption(op);
      this.init();

      // const that = this;
      // let index = 0;
      // clearInterval(this.timer);
      // this.timer = setInterval(() => {
      //   this.myChart.dispatchAction({
      //     type: "showTip",
      //     seriesIndex: 0,
      //     dataIndex: index
      //   });
      //   index++;
      //   // console.log(index)
      //   if (index >= 6) {
      //     index = 0;
      //   }
      // }, 3000);
    }
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null;
  },
  mounted() {
    // this.tableData = this.salesData
    // var time = ['oneDay', 'twoDay', 'threeDay', 'fourDay', 'fiveDay', 'sixDay', 'sevenDay']
    // var myDate = new Date();
    // myDate.setDate(myDate.getDate() - 7);
    // var dateArray = []
    // var dateTemp;
    // var flag = 1;
    // for (var i = 0; i < time.length; i++) {
    //   let day = myDate.getDate() + i + 1;
    //   dateTemp = (myDate.getMonth() + 1) + "-" + day
    //   this.dataY.push(this.salesDataBar[0][time[i]])
    //   this.dataX.push(dateTemp)
    // }

    // this.dataY = [80, 50, 60, 100, 150, 120]
    // this.dataX = ['1-18', '19-22', '23-35', '36-55', '56-75', '76-90']
    var self = this;
    self.chart();
    self.init();
    // this.timer = setInterval(() => {
    //   self.getData()
    // }, 3000);
  }
};
</script>



// WEBPACK FOOTER //
// index.vue?5eb718b4